export default {
    SET_USER_CALCULATED_NAME: 'SET_USER_CALCULATED_NAME',
    SET_USER_NAME: 'SET_USER_NAME',
    USER_NAME: 'USER_NAME',
    USER_CALCULATED_NAME: 'USER_CALCULATED_NAME',
    SET_USER_PHOTO: 'SET_USER_PHOTO',
    USER_PHOTO: 'USER_PHOTO',
    SET_USER_PHOTO_UPDATED: 'SET_USER_PHOTO_UPDATED',
    USER_PHOTO_UPDATED: 'USER_PHOTO_UPDATED',
    SET_TIME_ZONE: 'SET_TIME_ZONE',
    SET_LOCALE: 'SET_LOCALE',
    SET_FIRST_DAY_OF_WEEK: 'SET_FIRST_DAY_OF_WEEK',
    SET_INPUT_DATE: 'SET_INPUT_DATE',
    TIME_ZONE: 'TIME_ZONE',
    LOCALE: 'LOCALE',
    FIRST_DAY_OF_WEEK: 'FIRST_DAY_OF_WEEK',
    INPUT_DATE: 'INPUT_DATE',
    SSP_THEME:'SSP_THEME',

    SET_IS_GUEST: 'SET_IS_GUEST',
    IS_GUEST: 'IS_GUEST'
}



// WEBPACK FOOTER //
// ./constants/user.js